import React from 'react';
import styled from 'styled-components';
import { TrevorComponent, TrevorIcon } from '@trevor/ui-components';
import ViewRef from '@/util/ViewRef';
import { useAppDispatch } from '@/store/hooks';
import { resetWidgetSavedQuery } from '@/features/dashboard/dashboardSlice';

export type SelectedSavedQueryProps = {
  widgetView: ViewRef; // TODO: refactor to SavedQuery.
};

const _SelectedSavedQuery: TrevorComponent<
  SelectedSavedQueryProps & React.ButtonHTMLAttributes<HTMLButtonElement>
> = ({ className, widgetView }) => {
  const dispatch = useAppDispatch();
  const resetView = () => dispatch(resetWidgetSavedQuery());

  return (
    <button className={className} onClick={resetView}>
      {widgetView.name()}
      <TrevorIcon name="close-small" />
    </button>
  );
};

export const SelectedSavedQuery = styled(_SelectedSavedQuery)`
  width: 100%;
  padding: 6px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--color-interface-neutral-light);
  border: 1px solid #ccc;
  border-radius: var(--radius-4);
  font-size: 14px;
  transition: background-color var(--transition-normal) ease;
  margin-bottom: var(--spacing-l);

  :hover {
    background-color: var(--color-interface-layout-lighter);
  }
`;
